export const COMPANY_ADMIN = 'Company Admin'
export const BILLING_ADMIN = 'Billing Admin'
export const COMPANY_AGENT = 'Company Agent'
export const COMPANY_REPORTER_ACCESS = 'Company Reporter Access'
export const COMPANY_SUPERVISOR = 'Company Supervisor'

/**
 * The roles that keep account-wide visibility. Every other role, Supervisors
 * included, is scoped by Inbox membership. Kept as one list so the visibility
 * rules and the settings screens that describe them cannot drift apart.
 */
export const UNRESTRICTED_ROLES = [COMPANY_ADMIN, BILLING_ADMIN]

/**
 * The roles api-core issues a TaskRouter token to; must match its token endpoint.
 */
export const TASK_ROUTER_ROLES = [COMPANY_AGENT, COMPANY_ADMIN, COMPANY_SUPERVISOR]

/**
 * True only when the roles are loaded and none of them gets a token. Roles not yet
 * loaded mean "don't know", so callers leave the lifecycle alone.
 *
 * @param {{ user_roles?: string[] }|null|undefined} profile
 * @returns {boolean}
 */
export function lacksTaskRouterRole (profile) {
  return Array.isArray(profile?.user_roles) &&
    !profile.user_roles.some(role => TASK_ROUTER_ROLES.includes(role))
}
